import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useAuthReady = () => {
  const { isAuthenticated, isLoading } = useAuth0();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const timer = setTimeout(() => {
        setIsReady(true);
      }, 50);
      
      return () => clearTimeout(timer);
    } else {
      setIsReady(false);
    }
  }, [isAuthenticated, isLoading]);

  return isReady;
};